import { useContext } from 'react';

import { PartnerIntakeContext } from '@/Contexts/PartnerIntakeContext';

import IntakeCountrySelect from './IntakeCountrySelect';
import IntakeLanguageSelect from './IntakeLanguageSelect';
import ExistingPartnerSelect from '../common/ExistingPartnerSelect';
import NewPartnerSection from '../common/IntakeNewPartnerSection';
import NewPartnerSectionHeader from '../common/IntakeNewPartnerSectionHeader';
import IntakePrimaryContact from '../common/IntakePrimaryContact';
import IntakeShippingContact from '../common/IntakeShippingContact';
import IntakeSubmitButton from '../common/IntakeSubmitButton';
import NewPartnerCheckbox from '../common/NewPartnerCheckbox';
import PartnerCategoryInput from '../common/PartnerCategoryInput';
import PartnerNameInput from '../common/PartnerNameInput';
import { IntakeResponse } from '@/models/IntakeResponse';
import { ProgramProps } from '@/models/Program';
import { Box } from '@mui/material';

interface TreeCityWorldSignUpProps {
  onSubmit: (intakeResponse: IntakeResponse) => void;
  selectedProgramInfo: ProgramProps;
}

function TreeCityWorldSignUp({ onSubmit, selectedProgramInfo }: TreeCityWorldSignUpProps) {
  const { isNewPartner, disabledNewPartnerCheckbox, countryId } = useContext(PartnerIntakeContext);

  return (
    <>
      <Box display='flex' justifyContent='center' flexDirection='row' gap={3} width='80%'>
        <Box display='flex' flex={1}>
          <IntakeLanguageSelect />
        </Box>
        <Box display='flex' flex={1}>
          <IntakeCountrySelect />
        </Box>
      </Box>

      {countryId != null && (
        <>
          <IntakePrimaryContact />

          {!isNewPartner && <ExistingPartnerSelect />}

          {!disabledNewPartnerCheckbox && <NewPartnerCheckbox />}

          {isNewPartner && (
            <NewPartnerSection>
              <NewPartnerSectionHeader />

              {selectedProgramInfo.displayCategory && <PartnerCategoryInput />}

              <PartnerNameInput />
            </NewPartnerSection>
          )}

          <IntakeSubmitButton onSubmit={onSubmit} />
        </>
      )}
    </>
  );
}

export default TreeCityWorldSignUp;
